<template>
  <v-app>
    <v-container>
      <addAssetTitle
        v-on:Adddialogclose="Adddialog = false"
        :assetType="assetToAdd"
        v-if="Adddialog"
      />
      <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary">Create Asset</v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in addMenu"
            :key="index"
            @click="Adddialog = true; assetToAdd=item"
          >
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-layout mt-5 row wrap>
        <v-flex xs4 pr-3>
              <statTile url='/computerAssets' :readyData='computerReady' :recycleData='computerRecycled' :data='computerTotal' icon='computer' title='Desktops/Laptops'/>
        </v-flex>
        <v-flex xs4 pr-3>
              <statTile url='/monitorAssets' :readyData='monitorsReady' :recycleData='monitorsRecycle' :data='monitorsTotal' icon='desktop_mac' title='Monitors'/>
        </v-flex>
        <v-flex xs4 pr-3>
   <statTile url='/phoneAssets' :readyData='phonesReady' :recycleData='phonesRecycle' :data='phonesTotal' icon='smartphone' title='Phones'/>  
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>


<script>
import addAssetTitle from "../components/addAssetsType.vue"
import statTile from '../components/dashboardComp/StatTiles'
const fb = require("../firebaseConfig.js");
export default {
  components: {
    addAssetTitle,
    statTile
  },
  data() {
    return {
       items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
   {
          text: 'Inventory',
          disabled: true,
          to: 'inventory'
        },
      ],
      assetToAdd: "",
      Adddialog: false,
      addMenu: ["Computer", "Monitor", "Phone"],
      computerTotal: 0,
      monitorsTotal: 0,
      phonesTotal: 0,
       computerReady : 0,
      monitorsReady : 0,
      phonesReady : 0,
        computerRecycled : 0,
       monitorsRecycle : 0,
       phonesRecycle : 0,
    };
  },
  mounted() {
        fb.IndexCollections.doc("AssetsIndex")
      .onSnapshot(docs => {
        this.computerTotal = docs.data().total_computers
        this.monitorsTotal = docs.data().total_monitors
        this.phonesTotal = docs.data().total_cellphones
        this.computerRecycled = docs.data().recycled_computers
        this.monitorsRecycle = docs.data().recycled_monitors
        this.phonesRecycle = docs.data().recycled_cellphones
        this.computerReady = docs.data().ready_computers
        this.monitorsReady = docs.data().ready_monitors
        this.phonesReady = docs.data().ready_cellphones
      });
  }
};
</script>


<style scoped>
.background {
  background: rgb(53,52,68);
  background: linear-gradient(148deg, rgba(53,52,68,1) 17%, rgba(56,167,55,1) 78%);
}
</style>
